import DisplayNotifications from 'modules/terminal/pages/DisplayNotifications';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ROUTE_PATHS } from '../constants';
import { AssignPickUp, UseCases, SearchContainers } from '../pages';
import AcceptReleaseRight from '../pages/AcceptReleaseRight';
import RevokeReleaseRight from '../pages/RevokeReleaseRight';
import DeclineReleaseRight from '../pages/DeclineReleaseRight';
import UpdatePickUp from '../pages/UpdatePickUp';
import TransferReleaseRight from '../pages/TransferReleaseRight';
import CircularProgress from '@mui/material/CircularProgress';

type Props = React.ComponentPropsWithoutRef<'div'> & {
  creditIdentificationIsValid: boolean;
  loadingCreditIdentification: boolean;
};

const BetaTransportOperatorRoutes: React.FunctionComponent<Props> = ({
  creditIdentificationIsValid,
  loadingCreditIdentification,
}) => {
  if (loadingCreditIdentification) {
    return <CircularProgress />;
  }

  return (
    <Routes>
      <Route path={ROUTE_PATHS.UPDATE_PICKUP} element={<UpdatePickUp />} />
      <Route path={ROUTE_PATHS.ASSIGN_PICKUP} element={<AssignPickUp />} />
      <Route path={ROUTE_PATHS.REVOKE_RELEASE_RIGHT} element={<RevokeReleaseRight />} />
      <Route
        path={ROUTE_PATHS.ACCEPT_RELEASE_RIGHT}
        element={creditIdentificationIsValid ? <AcceptReleaseRight /> : <Navigate to="/blocked" />}
      />
      <Route path={ROUTE_PATHS.TRANSFER_RELEASE_RIGHT} element={<TransferReleaseRight />} />
      <Route path={ROUTE_PATHS.DECLINE_RELEASE_RIGHT} element={<DeclineReleaseRight />} />
      <Route path={ROUTE_PATHS.DISPLAY_NOTIFICATIONS} element={<DisplayNotifications />} />
      <Route path={ROUTE_PATHS.BASE_ROUTE} element={<UseCases />} />
      <Route path={ROUTE_PATHS.SEARCH_CONTAINERS} element={<SearchContainers />} />
    </Routes>
  );
};

export default BetaTransportOperatorRoutes;
